import { SET_POINT_MAP, 
         SET_POINT_MAP_STATION,  
} from "../actions/mapActions";

const initialState = {
  points: [],
  pointsStation: [],
  loadingDataInitial: false,
};

export default function mapReducer(state = initialState, action) {
  switch (action.type) {
    
    case SET_POINT_MAP:
      return {
        ...state,
        points: action.payload,
      };

    case SET_POINT_MAP_STATION:
      return {
        ...state,
        pointsStation: action.payload,
      };
        
    default:
      return state;
  }
};
